<template>
    <div class="data-steps">
        <div class="data-steps__title">
            <h3>{{ $t('connect.step1Title') }}</h3>
            <div class="text-description">
                {{ $t('connect.step1Description') }}
            </div>
        </div>
        <el-row :guter="20">
            <el-col :span="12" :xs="24" class="mb-sm-0 mb-2">
                <InputSearch v-model="q" :placeholder="$t('connect.step1Title')" @keydown.enter="getListWorkspace()" @search="getListWorkspace()"></InputSearch>
            </el-col>
            <el-col :span="12" :xs="24">
                <div class="data-steps__adds">
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 1 }" href="javascript:void(0)" @click="setLayout(1)">
                        <i class="fa fa-list"></i>
                    </a>
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 2 }" href="javascript:void(0)" @click="setLayout(2)">
                        <i class="fas fa-th"></i>
                    </a>
                    <Button type="primary" @click="onShowModalAddSpace">
                        <el-icon class="el-icon-plus"></el-icon>
                        {{ $t('connect.addWorkspace') }}
                    </Button>
                </div>
            </el-col>
        </el-row>
        <box-loading v-if="isLoading"></box-loading>
        <div class="py-2" v-else>
            <div v-if="layoutStep === 2">
                <template v-if="userInfo['has_setting']">
                    <div class="list-workspace">
                        <div class="card ribbon-vertical-left-wrapper cursor-pointer group" @click="setDataWorkspace('All')" :class="dataWorkspace.workspace_uid === null ? 'active' : ''">
                            <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataWorkspace.workspace_uid === null">
                                <i class="fa fa-star"></i>
                            </div>
                            <div class="media-img mb-2">
                                <img src="@/assets/img/consulting.svg" alt="" class="workspace-img" />
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="overflow_text text-name-space">{{ $t('workspace.main') }}</span>
                            </div>
                        </div>
                        <div
                            v-for="(item, index) in listWorkspaces"
                            @click="setDataWorkspace(item)"
                            :key="index + 'box'"
                            class="card ribbon-vertical-left-wrapper cursor-pointer group"
                            :class="dataWorkspace.workspace_uid === item.uid ? 'active' : ''"
                        >
                            <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataWorkspace.workspace_uid === item.uid">
                                <i class="fa fa-star"></i>
                            </div>
                            <div class="media-img mb-2">
                                <img :src="item.cover_url" alt="" class="workspace-img" />
                            </div>
                            <div class="icon-delete" :title="$t('button.delete')" @click="handleConfirmDeleteWorkspace(item)">
                                <i class="el-icon-delete" style="font-size: 25px"></i>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="overflow_text text-name-space hover-text" @click="kintoneWorkspace(item.uid, item.type)">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div v-else class="table-sm table-kb">
                <table class="table table-hover table-common">
                    <thead>
                        <tr>
                            <th></th>
                            <th>No.</th>
                            <th>{{ $t('workspace.image') }}</th>
                            <th>{{ $t('workspace.name') }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row-workspace" @click="setDataWorkspace('All')" :class="dataWorkspace.workspace_uid === null ? 'active' : ''">
                            <td>
                                <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataWorkspace.workspace_uid === null">
                                    <i class="fa fa-star"></i>
                                </div>
                            </td>
                            <td class="w-10" data-title="No.">1</td>
                            <td class="w-25" :data-title="$t('workspace.image')">
                                <img class="image-cover" src="@/assets/img/consulting.svg" alt="" />
                            </td>
                            <td :data-title="$t('workspace.name')">{{ $t('workspace.main') }}</td>
                            <td class="w-10 d-none d-sm-table-cell"></td>
                        </tr>
                        <tr
                            v-for="(item, index) in listWorkspaces"
                            @click="setDataWorkspace(item)"
                            :key="index + 'row'"
                            :class="dataWorkspace.workspace_uid === item.uid ? 'active' : ''"
                            class="row-workspace"
                        >
                            <td>
                                <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataWorkspace.workspace_uid === item.uid">
                                    <i class="fa fa-star"></i>
                                </div>
                            </td>
                            <td class="w-10" data-title="No.">{{ index + 2 }}</td>
                            <td class="w-25" :data-title="$t('workspace.image')">
                                <img class="image-cover" :src="item.cover_url" alt="" />
                            </td>
                            <td :data-title="$t('workspace.name')">{{ item.name }}</td>
                            <td class="w-10">
                                <Button type="primary" @click="handleConfirmDeleteWorkspace(item)">
                                    <el-icon class="el-icon-delete"></el-icon>
                                    {{ $t('button.delete') }}
                                </Button>
                            </td>
                        </tr>
                        <tr v-if="listWorkspaces.length === 0">
                            <td :colspan="5" class="text-center">
                                <el-empty :description="$t('workspace.noDataSetting')"></el-empty>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ul class="pagination m-0">
                <li class="page-item" @click="prevPage" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#">
                        <el-icon class="el-icon-d-arrow-left"></el-icon>
                    </a>
                </li>
                <li class="page-item" @click="nextPage" :class="{ disabled: listWorkspaces.length < 7 }">
                    <a class="page-link" href="#">
                        <el-icon class="el-icon-d-arrow-right"></el-icon>
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-footer footer-buttons">
            <Button @click="handleNextStep" :disabled="!(dataWorkspace.workspace_uid || dataWorkspace.workspace_uid === null)" classes="btn-sm" type="primary">
                {{ $t('connect.nextStep') }}
                <i class="el-icon-right"></i>
            </Button>
        </div>

        <!--      Popup Add Workspace-->
        <popup :show.sync="isShowPopup" modal-small :title="$t('connect.titleAddSpace')">
            <template #content>
                <div class="form-group mb-1">
                    <label for="idSpace">
                        {{ $t('connect.labelAddSpace') }}
                        <span class="text-danger">(*)</span>
                    </label>
                    <input type="text" :class="{ 'input-valid': errorInfo.workspace }" class="form-control" id="idSpace" @keyup.enter="onAddWorkspace" v-model="workspace" />
                    <error-message-auth :error="errorInfo.workspace">
                        {{ errorInfo.workspace }}
                    </error-message-auth>
                </div>

                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="checkTypeSpace" id="flexCheckChecked" />
                    <label class="form-check-label" style="line-height: 1" for="flexCheckChecked">
                        {{ $t('connect.textCheckBoxAddSpace') }}
                    </label>
                </div>
            </template>
            <template #footer>
                <div class="text-right py-2">
                    <Button type="warning" @click="onCancelModal" classes="mr-2 btn-sm">
                        {{ $t('button.cancel') }}
                    </Button>
                    <Button type="primary" :disabled="isLoading" v-loading="isLoading" @click="onAddWorkspace" classes="btn-sm">
                        {{ $t('button.add') }}
                    </Button>
                </div>
            </template>
        </popup>
    </div>
</template>

<script>
import Button from '@/components/partials/Button';
import InputSearch from '@/components/partials/customs/InputSearch';
import Popup from '@/components/partials/Popup';
import { mapState } from 'vuex';
import ErrorMessageAuth from '@/views/auth/errorMessageAuth';
import { validRequired } from '@/utils';
import BoxLoading from '@/components/partials/BoxLoading';

export default {
    name: 'step-workspace',
    props: ['data'],
    components: {
        BoxLoading,
        ErrorMessageAuth,
        Popup,
        InputSearch,
        Button
    },
    data() {
        return {
            layoutStep: parseInt(localStorage.getItem('layoutStep1')) || 2,
            isShowPopup: false,
            isLoading: false,
            q: '',
            page: parseInt(localStorage.getItem('layoutPage1')) || 1,
            limit: 7,
            currentPage: 1,
            total: '',
            workspace: '',
            errorInfo: {
                workspace: ''
            },
            dataWorkspace: this.data || {},
            listWorkspaces: [],
            listData: [],
            checkDisbleNext: false,
            checkDisblePrev: false,
            checkTypeSpace: false
        };
    },
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    created() {
        this.dataWorkspace = this.data;
        this.getListWorkspace();
    },
    watch: {
        dataWorkspace: {
            deep: true,
            handler: function () {
                this.$emit('update:data', this.dataWorkspace);
            }
        },
        isShowPopup(val) {
            if (!val) {
                this.checkTypeSpace = false;
                this.errorInfo.workspace = '';
                this.workspace = '';
            }
        }
    },
    methods: {
        handleNextStep() {
            if (this.userInfo['information_group']['data_link'] >= this.userInfo['plan']['number_data_link'] && !this.$route.query.id) {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: this.$t('connect.planUserSmall')
                });
            } else {
                this.$emit('nextStep');
            }
            localStorage.setItem('layoutPage2', 1);
        },
        kintoneWorkspace(id, type) {
            if (type === 2) {
                let linkKintoneWorkspace = this.userInfo.url_kintone + '/k/guest/' + id + '/#/space/' + id;
                return window.open(linkKintoneWorkspace, '_blank');
            }
            let linkKintoneWorkspace = this.userInfo.url_kintone + '/k/#/space/' + id;
            window.open(linkKintoneWorkspace, '_blank');
        },

        handleConfirmDeleteWorkspace(item) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('connect.deleteWorkspaceConfirm'),
                callback: () => {
                    this.deleteWorkspace(item.uid);
                }
            });
        },
        deleteWorkspace(uid) {
            let successCallback = () => {
                this.getListWorkspace();
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: this.$t('connect.deleteWorkspaceSuccess')
                });
            };
            let errorCallback = () => {};

            let payload = {
                data: {
                    uid: uid
                },
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingAccount/deleteWorkspace', payload);
        },
        setLayout(type) {
            this.layoutStep = type;
            localStorage.setItem('layoutStep1', type);
        },
        onShowModalAddSpace() {
            let { userInfo } = this;
            if (userInfo && userInfo['has_setting']) {
                this.isShowPopup = true;
            } else {
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'error',
                    message: this.$t('connect.settingNotFound')
                });
            }
        },
        onCancelModal() {
            this.isShowPopup = false;
            this.checkTypeSpace = false;
            this.errorInfo.workspace = '';
            this.workspace = '';
        },
        onAddWorkspace() {
            let check = this.validateWorkspace();
            let uid = this.getUid();
            let typeSpace = this.checkTypeSpace ? 2 : 1;
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = (response) => {
                    this.workspace = '';
                    this.getListWorkspace();
                    this.isShowPopup = false;
                    this.checkTypeSpace = false;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('connect.msgAddWorkspaceSuccess')
                    });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let payload = {
                    successCallback,
                    errorCallback,
                    data: {
                        uid: uid,
                        type: typeSpace
                    }
                };
                this.$store.dispatch('settingAccount/addWorkspace', payload);
            }
        },
        getListWorkspace() {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                const { data } = response.data;
                this.total = data.metadata.total;
                this.currentPage = data.metadata['current_page'];
                if (this.page * 7 >= this.total) {
                    this.checkDisbleNext = true;
                } else {
                    this.checkDisbleNext = false;
                }
                if (this.page === 1 || !this.page) {
                    this.checkDisblePrev = true;
                } else {
                    this.checkDisblePrev = false;
                }
                this.listWorkspaces = data.data;
                this.listData = data.data;
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                query: this.getQuery(),
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingAccount/getListWorkspace', payload);
        },
        getQuery() {
            let query = 'q=' + this.q + '&page=' + this.page + '&limit=' + this.limit;
            return query;
        },
        setDataWorkspace(item) {
            if (item === 'All') {
                this.dataWorkspace.workspace_type = 1;
                this.dataWorkspace.workspace_id = null;
                this.dataWorkspace.workspace_uid = null;
            } else {
                this.dataWorkspace.workspace_type = item.type;
                this.dataWorkspace.workspace_id = item.id;
                this.dataWorkspace.workspace_uid = item.uid;
            }
            localStorage.setItem('layoutPage1', this.page);
        },
        getUid() {
            let uid = '';
            let stringHead = 'space/';
            let stringFoot = '/thread';
            if (this.workspace.includes(stringHead)) {
                let begin = this.workspace.indexOf(stringHead) + 6;
                let end = this.workspace.indexOf(stringFoot);
                uid = this.workspace.substring(begin, end);
            } else {
                uid = this.workspace;
            }
            return uid;
        },
        validateWorkspace() {
            let check = true;
            if (!validRequired(this.workspace)) {
                check = false;
                this.errorInfo.workspace = this.$t('connect.msgWorkspaceRequired');
            } else {
                this.errorInfo.workspace = '';
            }

            return check;
        },
        nextPage() {
          if (this.listWorkspaces && this.listWorkspaces.length === 7) {
              if (!this.page) {
                  this.page = 1;
              }
              this.page++;
              if ((this.page - 1) * 7 < this.total) {
                  this.getListWorkspace();
              } else {
                  this.page--;
              }
              if (this.page * 7 >= this.total) {
                  this.checkDisbleNext = true;
              }
              localStorage.setItem('layoutPage1', this.page);
          }
        },
        prevPage() {
            if (this.page > 1) {
                this.page--;
                this.getListWorkspace();
                if (this.page * 7 < this.total) {
                    this.checkDisblePrev = true;
                }
            }
            localStorage.setItem('layoutPage1', this.page);
        }
    }
};
</script>
